import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, onMounted, ref } from "vue";
import { usePrivateRates } from "@/services/TablePage/private-rates";
import { IColumnsGroup } from "@/utils/ColumnsCreator";
import ListLayout from "@/components_v3/layout/ListLayout.vue";
import TableColumns from "@/components-UI/table/columns/TableColumns.vue";
import PrivateRatesTable from "@/components_v3/offers/private-rates/PrivateRatesTable.vue";
import PrivateRatesFilters from "@/components/offers/private-rates/PrivateRatesFilters.vue";
import CreateButton from "@/components-UI/buttons/CreateButton.vue";
import store from "@/store";
import { USER_ROLES } from "@/mappings/user-roles";
import DownloadButton from "@/components-UI/buttons/DownloadButton.vue";
import ReloadButton from "@/components-UI/buttons/ReloadButton.vue";
import { downloadExcelFile, showServerError } from "@/utils";
import { exportPrivateRates } from "@/api/offers";
import { useWindowResize } from "@/utils/useWindowSize";
import { useRoute, useRouter } from "vue-router/composables";
import { usePrivateRatesStore } from "@/store_v3/PrivateRatesStore";
import { storeToRefs } from "pinia";


export default /*#__PURE__*/_defineComponent({
  __name: 'PrivateRateList',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const { width } = useWindowResize();
const isMobile = computed(() => width.value < 576);

const { clearForm } =usePrivateRatesStore();
const { createForm } = storeToRefs(usePrivateRatesStore());
const { getColumns, getDefaultColumns } = usePrivateRates();
const columns = ref<IColumnsGroup[]>([]);
const columnsEl = ref<TableColumns | null>(null);

onBeforeMount(() => {
    columns.value = getColumns();
});

onMounted(() => {
    columnsEl?.value?.resetColumns();
});

const isShowCreate = computed(() => {
    const userRoles = store.getters['authModule/GET_USER'].roles;
    return [USER_ROLES.ADMIN, USER_ROLES.ACCOUNT_MANAGER, USER_ROLES.SUPERVISOR].some(role => userRoles.includes(role));
});

const privateRatesTable = ref<InstanceType<typeof PrivateRatesTable> | null>(null);
const isExportLoading = ref(false);

const exportRates = async () => {
    try {
        isExportLoading.value = true;
        const params = privateRatesTable.value?.getParams();
        const file = await exportPrivateRates(params);
        downloadExcelFile(file, name, 'csv');
    } catch (err) {
        showServerError(err, 'Не удалось скачать выгрузку');
    } finally {
        isExportLoading.value = false;
    }
};

const reloadRates = () => {
    privateRatesTable.value?.getRatesList();
};

const goToCreate = () => {
    clearForm();
    const query = {};
    if (route.name === 'offer') {
        createForm.value.offerId = Number(route.params.id);
        query.from = 'offer';
    }
    if (route.name === 'affiliate') {
        createForm.value.affiliateId = Number(route.params.id);
        query.from = 'affiliate';
    }
    router.push({ name: 'create-private-rate', query });
};


return { __sfc: true,route, router, width, isMobile, clearForm, createForm, getColumns, getDefaultColumns, columns, columnsEl, isShowCreate, privateRatesTable, isExportLoading, exportRates, reloadRates, goToCreate, ListLayout, TableColumns, PrivateRatesTable, PrivateRatesFilters, CreateButton, DownloadButton, ReloadButton }
}

})